export const reviews = [
  {
    id: 1,
    name: '王明辉',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20person%20portrait%2C%20friendly%20smile%2C%20clean%20neutral%20background%2C%20corporate%20headshot%20style&width=120&height=120&seq=avatar-01&orientation=squarish',
    role: '影视从业者',
    rating: 5,
    content: '作为影视行业从业者，我对视频画质要求很高。精品视频精选平台的4K内容画质令我印象深刻，色彩还原准确，细节表现力极佳。分类体系也很专业，找纪录片和电影解析非常方便。',
    date: '2026-07-15',
  },
  {
    id: 2,
    name: '李思涵',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20warm%20smile%2C%20casual%20style%2C%20clean%20light%20background%2C%20natural%20lighting&width=120&height=120&seq=avatar-02&orientation=squarish',
    role: '大学生',
    rating: 5,
    content: '这个平台上的教育类视频质量太高了！尤其是高效学习法和语言学习系列，帮我节省了大量寻找优质学习资源的时间。界面简洁好用，推荐给所有爱学习的同学。',
    date: '2026-07-20',
  },
  {
    id: 3,
    name: '张建国',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Chinese%20man%20portrait%2C%20confident%20expression%2C%20business%20casual%2C%20clean%20light%20background%2C%20professional%20headshot&width=120&height=120&seq=avatar-03&orientation=squarish',
    role: '企业管理者',
    rating: 4,
    content: '工作之余喜欢看纪录片和科技前沿内容，这个平台完美满足了我的需求。内容精选度高，不会浪费时间在低质量视频上。希望未来能增加更多商业管理类的精品内容。',
    date: '2026-07-25',
  },
  {
    id: 4,
    name: '陈美玲',
    avatar: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20woman%20portrait%2C%20gentle%20smile%2C%20artistic%20style%2C%20soft%20warm%20background%2C%20creative%20atmosphere&width=120&height=120&seq=avatar-04&orientation=squarish',
    role: '自由职业者',
    rating: 5,
    content: '作为一个动漫迷和美食爱好者，这里就是我的快乐源泉！动漫解析系列做得特别用心，美食纪录片也让人看得口水直流。内容丰富更新快，已经成为我每天必刷的平台。',
    date: '2026-08-01',
  },
];

export const stats = [
  { value: '5000+', label: '精品视频' },
  { value: '8', label: '内容分类' },
  { value: '98%', label: '好评率' },
  { value: '200万+', label: '月活跃用户' },
];